import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import AnimatedBackground from './components/AnimatedBackground';
import SkeletonLoader from './components/SkeletonLoader';

// Lazy load admin components
const AdminLogin = lazy(() => import('./components/Admin/AdminLogin'));
const AdminRoute = lazy(() => import('./pages/AdminRoute'));
const UnfreezeAccount = lazy(() => import('./components/Admin/UnfreezeAccount'));
const UnblockIP = lazy(() => import('./components/Admin/UnblockIP'));

const AdminLoginPage = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <AdminLogin />
    </Suspense>
  );
};

const AdminRoutePage = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <AdminRoute />
    </Suspense>
  );
};

const UnfreezeAccountPage = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <UnfreezeAccount />
    </Suspense>
  );
};

const UnblockIPPage = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <UnblockIP />
    </Suspense>
  );
};

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-gray-900">
      <AnimatedBackground />
      <Router>
        <Routes>
          {/* Admin login routes */}
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path={`/${import.meta.env.VITE_ADMIN_MENU_PATH || 'admin'}/:accessKey`} element={<AdminLoginPage />} />
          
          {/* Admin panel routes */}
          <Route path="/admin/panel/*" element={<AdminRoutePage />} />
          <Route path="/admin/unfreeze" element={<UnfreezeAccountPage />} />
          <Route path="/unblock-ip/:token" element={<UnblockIPPage />} />
          
          {/* Catch-all routes */}
          <Route path="/:adminUrl" element={<AdminRoutePage />} />
          <Route path="/" element={<AdminLoginPage />} />
          <Route path="*" element={<AdminLoginPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
